/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Return_Virtual_LotInputs */

const vi_error_return_virtual_lot = /** @type {(inputs: Error_Return_Virtual_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hàng bán khi kho thiếu (lô chờ nhập bù) chưa trả được. Chờ kho nhập bù rồi trả lại.`)
};

/**

* @param {Error_Return_Virtual_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_return_virtual_lot = /** @type {((inputs?: Error_Return_Virtual_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Return_Virtual_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_return_virtual_lot(inputs)
});